import React from "react";
import { OutletCompletionInfoModel } from "../view_models/completion_view_model";

interface Props {
    tableName: string;
    completionData: OutletCompletionInfoModel[];
}

export default class CompletionTable extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <div id="CompletionOrderScreen">
                <h1 className="text-center font-bold text-lg">
                    {this.props.tableName}
                </h1>
                <table>
                    <thead className="bg-purple-300">
                        <th>Outlet Name</th>
                        <th>Kitchen</th>
                        <th>Max Cooking Time</th>
                    </thead>
                    <tbody>
                        {this.props.completionData?.map((model) => (
                            <tr
                                key={model.outlet_name}
                                style={{
                                    backgroundColor:
                                        // convert hours to minutes
                                        Number(model.max_cooking_time.split(":")[0]) * 60
                                            + Number(model.max_cooking_time.split(":")[1])
                                        > 15
                                            ? "#FF6961"
                                            : parseInt(
                                                  model.max_cooking_time.split(
                                                      ":"
                                                  )[1]
                                              ) > 5
                                            ? "#FDFD96"
                                            : "#FFFFFF",
                                }}
                            >
                                <td>{model.outlet_name}</td>
                                <td>{model.kitchen_record_qty}</td>
                                <td>{model.max_cooking_time}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}
